module.exports = __webpack_public_path__ + "img/bg-03.74c87068.png";